import { Injectable, inject } from '@angular/core';

import { MultiSportsHubConfig } from '@frontend/sports/common/client-config-data-access';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { Observable, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MultiSportsHubGuard {
    private multiSportsConfig = inject(MultiSportsHubConfig);
    redirectHelperService = inject(RedirectHelperService);

    canActivateChild(): Observable<boolean> {
        return this.multiSportsConfig.whenReady.pipe(
            map(() => {
                if (!this.multiSportsConfig.isEnabled) {
                    this.redirectHelperService.goHome();
                }
                return this.multiSportsConfig.isEnabled;
            }),
        );
    }
}
